const context = 'auth'

export const SIGN_IN = `${context}/SIGN_IN`

export const SIGN_OUT = `${context}/SIGN_OUT`
